import React from 'react';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { useStyles } from '../styles';

export type AuditListCellProps = {
  primary: string;
  secondary?: string;
  timestamp: string;
};

export function AuditListCell({
  primary,
  secondary,
  timestamp,
}: AuditListCellProps) {
  const styles = useStyles();

  return (
    <Box direction="column" className={styles.auditListCell}>
      <Text size="table">{primary}</Text>
      {secondary ? (
        <Text
          size="table"
          color="default"
          className={styles.auditListCellSecondary}
        >
          {secondary}
        </Text>
      ) : null}
      <Text size="table" color="default">
        {timestamp}
      </Text>
    </Box>
  );
}
